import Vue from 'vue/dist/vue.min.js'
export const EventBus = new Vue()